import{ useState, useEffect, CSSProperties ,React } from "react";
import ClipLoader from "react-spinners/ClipLoader";
import $ from 'jquery';
// core components
import Footer from "../components/Footer/Footer.js";
import Head from "../components/Header/Head.js";
import Donate from "../components/Donate/Donate.js";

import Diwali from "../assets/images/diwali.png"
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import Events from "../assets/images/events.jpg"
import Pongal from "../assets/images/pongal.png"
import News from "../assets/images/news.jpg"
import Chess from "../assets/images/Chess.jpg"
import Loader from "../components/loader/loader.js";
import {Link} from "react-router-dom";

export default function Home() {
   const [loading, setLoading] = useState(true);
 
   useEffect(() => {
     const timer = setTimeout(() => {
       setLoading(false);
     }, 2500); 
 
     return () => clearTimeout(timer);
   }, []);
   $(window).scroll(function () {
    if ($(this).scrollTop()) {
      $('header').addClass('fixedTop');
    } else {
      $('header').removeClass('fixedTop');
    }
  });
  const options={
    dots: false,
    infinite: true,
    autoplayHoverPause:true,
    autoplay:true,
    smartSpeed: 4000,
    nav:false,
   margin:30,
    speed: 500,
    responsive:{
        0:{
            items:1,
            margin:10,
        },
        700:{
            items:2,
            margin:10,
        },
        1000:{
            items:3,
            margin:30,
        },
        1280:{
         items:3,
         margin:30,
     }
    },
   
}
 const events={
    dots: false,
    infinite: true,
    autoplayHoverPause:true,
    autoplay:true,
    smartSpeed: 4000,
    nav:false,
   margin:30,
    speed: 500,
    responsive:{
        0:{
            items:1,
            margin:40,
        },
        700:{
            items:2,
            margin:40,
        },
        1000:{
            items:3,
            margin:40,
        },
        1280:{
         items:3,
         margin:40,
     }
    },
   
}
  useEffect(() => {
   window.scrollTo(0, 0)
 }, [])
  return (
<div>
{loading ? <Loader /> :
    <div>
    
      <div className="home_header">
     
<section className="homebanner">
  
   <div className="homebanerheight">
      <div className="container-fluid custom-container">
         <div className="row">
            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
               <h2>Welcome To Jayam Charitable Trust</h2>
               <p >At Jayam Charitable Trust, Chennai, we believe in a world where true equality is yet to be fully realized. Though society appears to have moved forward, discrimination still persists—based on gender, caste, disability, status, and more. We stand with courage and compassion to eliminate such bias and pave pathways of opportunity for the visually impaired, and the elderly people</p>
              <h3><i>"When kindness turns into action, change begins."</i></h3>
              <div className="align_mobile">
                <div className="email_id_class">
               <input type="email" placeholder="Enter Email Address" />
               <Link to="/Donate"> <button class="button_svg">
  Donate Now
  <svg class="icon" viewBox="0 0 24 24" fill="currentColor">
    <path
      fill-rule="evenodd"
      d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm4.28 10.28a.75.75 0 000-1.06l-3-3a.75.75 0 10-1.06 1.06l1.72 1.72H8.25a.75.75 0 000 1.5h5.69l-1.72 1.72a.75.75 0 101.06 1.06l3-3z"
      clip-rule="evenodd"
    ></path>
  </svg>
</button></Link>
               </div>
              </div>
                             
            </div>
            <div className="col-lg-6 ">
                
            </div>
         </div>
      </div>
   </div>
</section>
<section className="quotes">
 <OwlCarousel className='owl-theme' {...options} >
      <div className="quotes_slider">
  <div class="infos">
    <p class="description"> "Charity begins at home, but should not end there. </p>
  </div>
  <div class="author"> — Thomas Fuller </div>
</div>
      <div className="quotes_slider">
  <div class="infos">
    <p class="description">"No one has ever become poor by giving." </p>
  </div>
  <div class="author"> — Anne Frank </div>
</div>
      
      <div className="quotes_slider">
  <div class="infos">
    <p class="description">"If you can’t feed a hundred people, then feed just one."</p>
  </div>
  <div class="author"> — Mother Teresa</div>
</div>
      <div className="quotes_slider">
  <div class="infos">
    <p class="description">"Compassion is the root of charity"</p>
  </div>
  <div class="author"> — Lailah Gifty Akita</div>
</div>

      <div className="quotes_slider">
  <div class="infos">
    <p class="description">"It's not how much we give but how much love we put into giving."</p>
  </div>
  <div class="author"> — Mother Teresa </div>
</div>
   </OwlCarousel>
</section>
       <section className="events owcarourel">
            <div className="container-fluid custom-container">
               <h2>Recent Events at Jayam Charitable Trust</h2>
             <OwlCarousel className='owl-theme events' {...events} >
                  <Link to="/Events">  
                  <div className="event_card">
                     <div className="event_img">
                        <img src={Events} alt="events" />
                     </div>
                     <div className="event_content">
                      <div>
                        <h5>4 Oct 2024</h5>
                        </div>
                        <h3>🌟 ARMADHAM '24 – A Grand Celebration of History, Culture, and Light 🌟</h3>
                       </div>

                   </div>
                   </Link>
                   {/* <Link to="/Events">  
                   <div className="event_card">
                     <div className="event_img">
                        <img src={Medical} alt="events" />
                     </div>
                     <div className="event_content">
                        <div>
                        <h5>15 June2025</h5>
                        </div>
                        <h3>Medical Camp Services</h3>
                        </div>

                   </div></Link> */}
                    <Link to="/Events"> 
                   <div className="event_card">
                     <div className="event_img">
                        <img src={Pongal} alt="events" />
                     </div>
                     <div className="event_content">
                          <div>
                        <h5>15 Jan 2025</h5>
                        </div>
                        <h3>🌾 Pongal 2025 – A Celebration of Light, Love, and Humanity 🌾</h3>
                        </div>

                   </div></Link>
                    <Link to="/Events"> 
                   <div className="event_card">
                     <div className="event_img">
                        <img src={Chess} alt="Chess" />
                     </div>
                     <div className="event_content">
                          <div>
                        <h5>15 Jun 2025</h5>
                        </div>
                        <h3>State Level Chess Competition</h3>
                        </div>

                   </div></Link>
                    <Link to="/Events"> 
                   <div className="event_card">
                     <div className="event_img">
                        <img src={Diwali} alt="Diwali" />
                     </div>
                     <div className="event_content">
                          <div>
                        <h5>31 Oct 2024</h5>
                        </div>
                        <h3>✨ Diwali 2024 – A Spark of Light and Generosity ✨</h3>
                        </div>

                   </div></Link>
                    <Link to="/Events"> 
                   <div className="event_card">
                     <div className="event_img">
                        <img src={News} alt="news" />
                     </div>
                     <div className="event_content">
                          <div>
                        {/* <h5>31 Oct 2024</h5> */}
                        </div>
                        <h3>✨ World Senior Citizen Day ✨</h3>
                        </div>

                   </div></Link>
                 </OwlCarousel>
             
            </div>
       </section>
      
          <Footer />
       
      </div>
    </div>
    }
    </div>
  )
}
